import React, { useState } from 'react';
import {
    Box,
    Grid,
    Paper,
    Typography,
  } from "@mui/material";
  

function AtomData() {
    const [address1, setAddress1] = useState('4529 Winona Court');
    const [address2, setAddress2] = useState('Denver, CO');
    const [apiKey, setApiKey] = useState('561ce7f9337562cb77f6d57645c916d2');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [data, setData] = useState(null);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        setData(null);

        try {
            const baseUrl = 'https://api.gateway.attomdata.com/propertyapi/v1.0.0/property/basicprofile';
            const url = `${baseUrl}?address1=${encodeURIComponent(address1)}&address2=${encodeURIComponent(address2)}`;

            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'accept': 'application/json',
                    'apikey': apiKey || 'value'
                }
            });

            if (!response.ok) {
                const text = await response.text();
                throw new Error(`Request failed: ${response.status} ${response.statusText} - ${text}`);
            }

            const json = await response.json();
            // Extract only required fields
            const property = json.property?.[0];
            console.log('property:', JSON.stringify(property));
            if (property) {
                const propertyId = property.identifier?.attomId


                if(propertyId) {
                    const baseUrl2 = 'https://api.gateway.attomdata.com/propertyapi/v1.0.0/property/basicprofile';
                    const url2 = `${baseUrl2}?attomid=${encodeURIComponent(propertyId)}`;

                    const response2 = await fetch(url2, {
                        method: 'GET',
                        headers: {
                            'accept': 'application/json',
                            'apikey': apiKey || 'value'
                        }
                    });
        
                    if (!response2.ok) {
                        const text2 = await response.text();
                        throw new Error(`Request failed: ${response2.status} ${response2.statusText} - ${text2}`);
                    }
        
                    const json2 = await response2.json();
                    const property2 = json2.property?.[0];

                    console.log('property2:', JSON.stringify(property2));
                    if (property2) {

                        const overall_data = {
                            propertyId: propertyId,
                            propsubtype: property.summary?.propSubType,
                            propertyType: property.summary?.propertyType,
                            legal1: property.summary?.legal1,
                            ownerName: property.assessment?.owner?.owner1?.fullName,
                            address:property2.address?.oneLine,
                            salesearchdate:property2.sale?.saleSearchDate,
                            saleTransDate:property2.sale?.saleTransDate,
                            saleamt:property2.sale?.saleAmountData?.saleAmt,
                            salerecdate:property2.sale?.saleAmountData?.saleRecDate
                        }

                        console.log('overall_data:', JSON.stringify(overall_data));

                        setData(overall_data);
                    }
                }
            }
        } catch (err) {
            setError(err.message || 'Something went wrong');
        } finally {
            setLoading(false);
        }
    };

   
    // Render property details in a table
    const PropertyDetails = ({ data }) => {
        if (!data) return null;
      
        const rows = [
          { label: "Property ID", value: data.propertyId },
          { label: "Property Subtype", value: data.propsubtype },
          { label: "Property Type", value: data.propertyType },
          { label: "Legal Description", value: data.legal1 },
          { label: "Owner Name", value: data.ownerName },
          { label: "Address", value: data.address },
          { label: "Sale Search Date", value: data.salesearchdate },
          { label: "Sale Transaction Date", value: data.saleTransDate },
          { label: "Sale Amount", value: data.saleamt ? `$${data.saleamt.toLocaleString()}` : "" },
          { label: "Sale Recorded Date", value: data.salerecdate },
        ];
      
        return (
          <Box sx={{ p: 3 }}>
            <Typography variant="h5" gutterBottom>
              Property Details
            </Typography>
            <Paper elevation={3} sx={{ p: 2, borderRadius: 2 }}>
              <Grid container direction="column" spacing={1}>
                {rows.map((row, idx) => (
                  <Grid
                    key={idx}
                    item
                    sx={{
                      backgroundColor: idx % 2 === 0 ? "#f9f9f9" : "#fff",
                      p: 1,
                      borderRadius: 1,
                    }}
                  >
                    <Typography>
                      <strong>{row.label}:</strong> {row.value}
                    </Typography>
                  </Grid>
                ))}
              </Grid>
            </Paper>
          </Box>
        );
      };
      

    return (
        <div style={{ padding: '2rem', fontFamily: 'Segoe UI, Arial, sans-serif', maxWidth: 900, margin: '0 auto' }}>
            <h1>ATTOM Property Expanded Profile</h1>
            <form onSubmit={handleSubmit} style={{ display: 'grid', gap: '12px', marginBottom: '1rem' }}>
                <div style={{ display: 'grid', gap: 6 }}>
                    <label htmlFor="address1">Address Line 1</label>
                    <input
                        id="address1"
                        type="text"
                        value={address1}
                        onChange={(e) => setAddress1(e.target.value)}
                        placeholder="4529 Winona Court"
                        style={{ padding: '10px', border: '1px solid #ccc', borderRadius: 6 }}
                        required
                    />
                </div>

                <div style={{ display: 'grid', gap: 6 }}>
                    <label htmlFor="address2">City, State</label>
                    <input
                        id="address2"
                        type="text"
                        value={address2}
                        onChange={(e) => setAddress2(e.target.value)}
                        placeholder="Denver, CO"
                        style={{ padding: '10px', border: '1px solid #ccc', borderRadius: 6 }}
                        required
                    />
                </div>

                <div style={{ display: 'grid', gap: 6 }}>
                    <label htmlFor="apikey">API Key (apikey header)</label>
                    <input
                        id="apikey"
                        type="password"
                        value={apiKey}
                        onChange={(e) => setApiKey(e.target.value)}
                        placeholder="Enter your ATTOM API key"
                        style={{ padding: '10px', border: '1px solid #ccc', borderRadius: 6 }}
                    />
                    <small style={{ color: '#666' }}>If left blank, the header will use the literal value 'value'.</small>
                </div>

                <button type="submit" disabled={loading} style={{ padding: '10px 16px', background: '#6A1B9A', color: 'white', border: 'none', borderRadius: 6, cursor: 'pointer' }}>
                    {loading ? 'Fetching…' : 'Submit'}
                </button>
            </form>

            {error && (
                <div style={{ color: '#b00020', background: '#fde7e9', border: '1px solid #f5c2c7', borderRadius: 6, padding: '10px', marginBottom: '1rem' }}>
                    {error}
                </div>
            )}

            {data && <PropertyDetails data={data} />}
        </div>
    );
}

export default AtomData;
